export class VEmpCng {
  numEmp: string;
  nom: string;
  prenom: string;
  dateNaiss: Date;
  email: string;
  nbrJours: number;
  nbrReliquat: number;
}
